var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 0V1.16667H11.6667V2.33333H12.8333V4.66667H14V9.33333H12.8333V11.6667H11.6667V12.8333H9.33333V14H4.66667V12.8333H2.33333V11.6667H1.16667V9.33333H0V4.66667H1.16667V2.33333H2.33333V1.33333H2.77222C2.77467 1.33333 2.794 1.32267 2.79711 1.31933L2.81111 1.16667H4.66667V0H9.33333ZM8.16667 1.16667H5.83333V2.33333H3.5V3.5H2.33333V5.83333H1.16667V8.16667H2.33333V10.5H3.5V11.6667H5.83333V12.8333H8.16667V11.6667H10.5V10.5H11.6667V8.16667H12.8333V5.83333H11.6667V3.5H10.5V2.33333H8.16667V1.16667Z",
    fill: "#00FFA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.5V7H10.5V8.16667H5.83333V3.5H7Z",
    fill: "#00FFA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.ca4909670520a57ea8275ee6f0793ecf.svg";
export { ForwardRef as ReactComponent };